import { useTranslation } from 'react-i18next';
import Layout from '@/components/feature/Layout';

export default function Impressum() {
  const { t } = useTranslation();

  return (
    <Layout>
      {/* Page Header */}
      <div className="bg-foreground-900 pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <span className="text-accent-400 text-sm font-medium uppercase tracking-wider mb-4 block">
            {t('footer.imprint')}
          </span>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
            {t('impressumPage.title')}
          </h1>
        </div>
      </div>

      {/* Content */}
      <section className="py-16 md:py-24 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
            {/* Left Column - Company Info */}
            <div className="space-y-12">
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">
                  Angaben gemäß § 5 TMG
                </h2>
                <div className="bg-background-50 rounded-xl border border-background-200 p-6 space-y-4">
                  <p className="text-foreground-700">
                    <strong className="text-foreground-900">Maschinenfabrik Bock GmbH & Co. KG</strong>
                    <br />
                    Altenaer Straße 170
                    <br />
                    58513 Lüdenscheid
                  </p>
                  <p className="text-foreground-700">
                    <strong>Vertreten durch:</strong>
                    <br />
                    Dipl.-Ing. Karsten Bock
                  </p>
                  <p className="text-foreground-700">
                    <strong>Kontakt:</strong>
                    <br />
                    Telefon: +49 (0) 2351 / 5 21 33
                    <br />
                    Telefax: +49 (0) 2351 / 5 26 70
                    <br />
                    E-Mail: <a href="mailto:sales@bock-mf.de" className="text-primary-600 hover:text-primary-700 underline">sales@bock-mf.de</a>
                  </p>
                  <p className="text-foreground-700">
                    <strong>Registereintrag:</strong>
                    <br />
                    Eintragung im Handelsregister
                    <br />
                    Registergericht: Amtsgericht Iserlohn
                    <br />
                    Registernummer: HRB 6344, HRA 4344
                  </p>
                  <p className="text-foreground-700">
                    <strong>Umsatzsteuer-ID:</strong>
                    <br />
                    Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
                    <br />
                    DE 814897916
                  </p>
                  <p className="text-foreground-700">
                    <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong>
                    <br />
                    Dipl.-Ing. Karsten Bock
                  </p>
                </div>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">
                  Design & Programmierung
                </h2>
                <div className="bg-background-50 rounded-xl border border-background-200 p-6">
                  <div className="flex items-start gap-4">
                    <img
                      src="https://www.bock-mf.de/typo3temp/pics/96bec64d57.png"
                      alt="mmh kommunikationsagentur"
                      className="w-[92px] h-[150px] object-contain flex-shrink-0 rounded-lg"
                      onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                    />
                    <div className="text-foreground-700 space-y-2">
                      <p>
                        <strong>mmh kommunikationsagentur GmbH</strong>
                      </p>
                      <p>
                        Herscheider Landstraße 89
                        <br />
                        D-58515 Lüdenscheid
                      </p>
                      <p>
                        <strong>Telefon:</strong> +49 (0) 23 51 / 67 90-0
                        <br />
                        <strong>Telefax:</strong> +49 (0) 23 51 / 67 90-199
                      </p>
                      <p>
                        <strong>E-Mail:</strong>{' '}
                        <a href="mailto:post@mmh.ag" className="text-primary-600 hover:text-primary-700 underline">
                          post@mmh.ag
                        </a>
                        <br />
                        <strong>Internet:</strong>{' '}
                        <a href="http://www.mmh.ag/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700 underline">
                          www.mmh.ag
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Legal */}
            <div className="space-y-8">
              <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-4">
                Rechtliches
              </h2>

              <div className="space-y-6">
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                    Haftung für Inhalte
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                  </p>
                </div>

                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                    Haftung für Links
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                  </p>
                </div>

                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                    Urheberrecht
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                  </p>
                </div>

                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                    Datenschutz
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.
                  </p>
                </div>
              </div>

              <p className="text-foreground-500 text-sm italic mt-8">
                Quelle: <a href="http://www.e-recht24.de/muster-disclaimer.htm" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700 underline">Disclaimer eRecht24</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}